import { servletGetResults } from './helpers';

export default class GoogleDAO {

  constructor(urls) {
    this.GOOGLE_LOCATIONS_API = urls.GOOGLE_LOCATIONS_API;
    this.GOOGLE_PLACES_API = urls.GOOGLE_PLACES_API;
  }

  getLocations(search, type) {
    if (typeof search !== 'string' || search.trim().length === 0) {
      return Promise.reject(new Error('Invalid search string'));
    }

    return servletGetResults(this.GOOGLE_LOCATIONS_API, { search, type }, false);
  }

  getPlaces(search, type) {
    if (typeof search !== 'string' || search.trim().length === 0) {
      return Promise.reject(new Error('Invalid search string'));
    }

    return servletGetResults(this.GOOGLE_PLACES_API, { search, type }, false)
      .then((resultObject) => resultObject.results);
  }
}



// WEBPACK FOOTER //
// ./src/js/util/dao/GoogleDAO.js